'use client'

import cn from '@config/tailwind/cn'

import { Button } from './button'

interface CalloutBoxProps {
  className?: string
  heading: string
  ctaText?: string
  link?: string
}

export function CalloutBox({ heading, ctaText, link, className }: CalloutBoxProps) {
  return (
    <div
      className={cn(
        'ui:border-main-blue-100 ui:text-complementary-black ui:border ui:my-6 ui:rounded-xl ui:p-6 ui:bg-main-blue-10',
        className,
      )}
    >
      <div className='ui:flex ui:flex-col ui:items-center ui:text-center ui:justify-between ui:gap-4'>
        <h4 className='ui:text-lg ui:font-medium'>{heading}</h4>
        {ctaText && link && (
          <Button asChild>
            <a href={link} target='_blank' rel='noopener noreferrer' className='ui:shadow-lg ui:hover:shadow-xl'>
              {ctaText}
            </a>
          </Button>
        )}
      </div>
    </div>
  )
}
